import { useState, useEffect } from "react";
import { AISidebar } from "../shares/AISidebar";
import AISidebarAsk from "../ai/AISidebarAsk";
import { useParams } from "react-router-dom";

export const CollectionAsk = () => {
  const { collectionId, aiResponseSaveId } = useParams();
  const question = new URLSearchParams(window.location.search).get("question");
  const employeeId = new URLSearchParams(window.location.search).get(
    "employeeId"
  );
  // console.log("[CollectionAsk] aiResponseSaveId: ", aiResponseSaveId);

  return (
    <>
      <AISidebarAsk
        collectionId={collectionId}
        aiResponseSaveId={aiResponseSaveId}
        queryStringQuestion={question}
        employeeId={employeeId}
      />
    </>
  );
};
